import React from "react";
import { Tooltip } from "antd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import copy from "copy-to-clipboard";
import { Typography, IconButton } from "@mui/material";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import Events from "../../Analytics/Events";
import CustomIcon from "../../Components/CustomIcon";
import { useToast } from "../../Hooks/useToast";

function TextHyperLinkWithCopyIcon(text, type, onTextClick, record) {
  const { openNotification } = useToast();
  return (
    <>
      <Typography
        variant="tableRow"
        onClick={() => onTextClick(record)}
        sx={{
          ":hover": {
            color: ThemeProperties.blue_400 + " !important",
            cursor: "pointer",
          },
        }}
      >
        {text}
      </Typography>
      <Tooltip title={"Click to copy"}>
        <IconButton
         disableRipple
         disableTouchRipple
         disableFocusRipple
          onClick={(event) => {
            event.stopPropagation();
            copy(text);
            openNotification({ text: 'Copied to Clipboard' })
            Events(`Copied ${type}`);
            
          }}
        >
          <CustomIcon name="copy-icon" />
        </IconButton>
      </Tooltip>
    </>
  );
}

export default TextHyperLinkWithCopyIcon;
